import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    title: {
        //color: theme.palette.primary.main
        textAlign: 'center',
        // marginBottom: '10px',
        marginTop: '-30px',
        fontWeight: '700'
    },
    container: {
        marginTop: theme.spacing(3),
    },
    paper: {
        padding: '48px 48px 10px',
        backgroundColor: 'rgba(255,255,255,.3)'
    },
    buttons: {
        marginTop: theme.spacing(2)
    },
    forgotPassword: {
        marginTop: theme.spacing(3)
    },
    logo: {
        height: 80,
        width: 250
    },
    textCenter: {
        textAlign: 'center'
    }
}))


export default useStyles;